export default __webpack_public_path__ + "static/media/apple-calendar.b6dcb705.svg";